"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoundLbPerMegaBtu = exports.PoundLbPerKiloBtu = exports.GrainPerMegaBtu = exports.GrainPerKiloBtu = exports.GramPerMegaJoule = exports.GramPerKiloJoule = exports.PoundLbPerKiloWattHour = exports.GrainPerKiloWattHour = exports.GramPerKiloWattHour = exports.KilogramPerKiloWattHour = void 0;
var uom_1 = require("uom");
exports.KilogramPerKiloWattHour = uom_1.UnitFormat.createUnitFormat("kg/kWh", 2);
exports.GramPerKiloWattHour = uom_1.UnitFormat.createUnitFormat("g/kWh", 1);
exports.GrainPerKiloWattHour = uom_1.UnitFormat.createUnitFormat("gr/kWh", 1);
exports.PoundLbPerKiloWattHour = uom_1.UnitFormat.createUnitFormat("lb/kWh", 2);
exports.GramPerKiloJoule = uom_1.UnitFormat.createUnitFormat("g/KJ", 1);
exports.GramPerMegaJoule = uom_1.UnitFormat.createUnitFormat("g/MJ", 1);
exports.GrainPerKiloBtu = uom_1.UnitFormat.createUnitFormat("gr/KBTU", 1);
exports.GrainPerMegaBtu = uom_1.UnitFormat.createUnitFormat("gr/MBTU", 1);
exports.PoundLbPerKiloBtu = uom_1.UnitFormat.createUnitFormat("lb/KBTU", 2);
exports.PoundLbPerMegaBtu = uom_1.UnitFormat.createUnitFormat("lb/MBTU", 2);
//# sourceMappingURL=emission-format.js.map